module.exports = "<ul \n  uib-pagination\n  total-items=\"source.totalResults\"\n  items-per-page=\"limit\"\n  class=\"pagination-sm\"\n  ng-model=\"currentPage\"\n  ng-change=\"pageChanged()\"\n  previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\"\n  first-text=\"&laquo;\" last-text=\"&raquo;\"\n  boundary-links=\"true\"\n  max-size=\"5\"\n  rotate=\"false\"\n></ul>"


//////////////////
// WEBPACK FOOTER
// ./src/DataTable/DataTablePagination.html
// module id = 436
// module chunks = 0